import $ from 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/carousel';

var setLinkCardHeight = function setLinkCardHeight(x, currentMaxHeight) {
  $(window).on('load resize', function () {
    $($('.link-card-edge-layout')[x]).find($('.carousel-item .link-card-edge')).each(function (i) {
      var linkCard = $($('.link-card-edge-layout')[x]).find($('.carousel-item .link-card-edge'));
      var carouselItem = $($('.link-card-edge-layout')[x]).find($('.carousel-item'));
      var nextCardHeight = $($(linkCard)[i + 1]).height() || 0;
      var currentCardHeight = $($(linkCard)[i]).height();

      if (currentCardHeight <= 0) {
        $($(carouselItem)[i]).show();
        currentCardHeight = $($(linkCard)[i]).height();
        $($(carouselItem)[i]).hide();
      }

      currentCardHeight = currentMaxHeight > currentCardHeight ? currentMaxHeight : currentCardHeight;
      currentMaxHeight = currentCardHeight > nextCardHeight ? currentCardHeight : nextCardHeight;

      if ($(linkCard).length === i + 1) {
        $($('.link-card-edge-layout')[x]).find($('.carousel-item .link-card-edge')).height(currentMaxHeight);
      }
    });
  });
};

var setLinkCarouselFocus = function setLinkCarouselFocus(carouselID) {
  $("#".concat(carouselID, " .carousel-item")).find('.link-action, .link-action-inverted').attr('tabindex', '-1');
  $("#".concat(carouselID, " .carousel-item.active")).next().find('.link-action, .link-action-inverted').removeAttr('tabindex');
  $("#".concat(carouselID, " .carousel-item.active")).find('.link-action, .link-action-inverted').on('focusin', function () {
    $("#".concat(carouselID, " .carousel-item.active")).next().find('.link-action, .link-action-inverted').focus();
  });
};

var setLinkCardCarousel = function setLinkCardCarousel(carouselID, totalItems) {
  var lastCard = $($("#".concat(carouselID, " .carousel-item"))[totalItems - 1]).detach().addClass('active');
  var cardNumber = 1; // Set text next to control arrows

  $("#".concat(carouselID, " .total-items")).text(totalItems);
  $("#".concat(carouselID, " .card-number")).text(cardNumber); // Pop and Push last card to front of Set (to make the 1st card selected in carousel)

  $($("#".concat(carouselID, " .carousel-item"))[0]).removeClass('active');
  $(lastCard).prependTo($("#".concat(carouselID, " .carousel-inner")));
  setLinkCarouselFocus(carouselID);
  $("#".concat(carouselID)).on('slide.bs.carousel', function (e) {
    var $e = $(e.relatedTarget);
    var idx = $e.index();

    var appendToCarousel = function appendToCarousel(itemsPerSlide, ind) {
      if (idx >= totalItems - itemsPerSlide) {
        var it = itemsPerSlide - (totalItems - idx); // eslint-disable-next-line no-plusplus

        for (var i = 0; i < it; i++) {
          // append slides to end
          var index = ind === 0 ? 0 : i;
          $("#".concat(carouselID, " .carousel-item")).eq(index).appendTo("#".concat(carouselID, " .carousel-inner"));
        }
      }
    };

    if (e.direction === 'left') {
      cardNumber += 1;
      appendToCarousel(3);
    } else {
      cardNumber -= 1;
      appendToCarousel(4, 0);
    }

    cardNumber = cardNumber === totalItems || cardNumber === 0 ? totalItems : Math.abs(cardNumber) % totalItems;
    $("#".concat(carouselID, " .card-number")).text(cardNumber);
  });
  $("#".concat(carouselID)).carousel({
    interval: false
  });
  $("#".concat(carouselID)).on('slid.bs.carousel', function () {
    setLinkCarouselFocus(carouselID);
  });
};

var animatedElements = $('.link-card-edge-layout').find('.animate__animated'); // check if browser is Internet Explorer

var isIE =
/* @cc_on!@ */
false || !!document.documentMode;

var showAnimatedElement = function showAnimatedElement() {
  animatedElements.each(function (i, el) {
    if (!isIE) {
      var $el = $(el).parent();
      var topOfEl = $el.offset().top;
      var bottomOfEl = $el.offset().top + $el.outerHeight();
      var bottomOfView = $(window).scrollTop() + $(window).innerHeight();
      var topOfView = $(window).scrollTop();
      var breakpoint = window.cigna.screen.breakpoint;

      if (!['xs', 'sm', 'md'].includes(breakpoint)) {
        if (topOfView > bottomOfEl) {
          $(el).removeClass('animation-delay animate__animated');
        } else if (bottomOfView > topOfEl && topOfView < bottomOfEl && $(el).hasClass('animation-delay')) {
          $(el).removeClass('animation-delay');
        }
      } else {
        $(el).removeClass('animation-delay animate__animated');
      }
    } else {
      $(el).removeClass('animation-delay animate__animated');
    }
  });
};

export default (function () {
  showAnimatedElement();
  $(window).on('scroll', function () {
    showAnimatedElement();
  });
  $('.link-card-edge-layout').each(function (x) {
    var carouselID = $($('.link-card-edge-layout')[x]).find($('[id^="linkCardCarousel"]')).attr('id');
    var totalItems = $("#".concat(carouselID, " .carousel-item")).length;
    setLinkCardHeight(x, 0);
    setLinkCardCarousel(carouselID, totalItems);
  });
});